module.exports = __webpack_public_path__ + "assets/img/Large_2.232fc8fa.svg";